import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSurveyDetail extends Layout {
    buttonTestSQL: Button;
    horizontalspacer1: HorizontalSpacer;
    labelQueryStatus: Label;
    labelSqlQuery: Label;
    panel2: Panel;
    panelSurveyDetail: Panel;
    sourceTia3plSurveyDetail: DataSource;
    switchActive: Switch;
    textboxCodeName: Textbox;
    textboxDataCode: Textbox;
    textboxDescription: Textbox;
    textboxSqlQuery: Textbox;
}
